import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { byPrefixAndName } from '@awesome.me/kit-f089350b06/icons';

import * as S from '../../styled';

const Header = ({ searchInputRef, query, setQuery, onClose }) => {
  const { t } = useTranslation();

  return (
    <S.Header>
      <S.SearchIcon>
        <FontAwesomeIcon icon={byPrefixAndName.fas.search} size="xl" />
      </S.SearchIcon>

      <S.SearchInput
        ref={searchInputRef}
        placeholder={t('search:common.placeholder')}
        value={query}
        onChange={(event) => setQuery(event.target.value)}
      />

      <S.IconButton type="button" onClick={onClose} aria-label={t('search:common.close')}>
        <FontAwesomeIcon icon={byPrefixAndName.far.xmark} size="lg" />
      </S.IconButton>
    </S.Header>
  );
};

Header.propTypes = {
  searchInputRef: PropTypes.shape({ current: PropTypes.any }).isRequired,
  query: PropTypes.string.isRequired,
  setQuery: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Header;
